<template>
  <p class="mt-2">
    There are many different parameters you can configure before running your simulation. These parameters use default
    values, but you can change them to suit your needs. <br />
  </p>
</template>

<script>
export default {
  name: 'Configure'
}
</script>
